<template>
  <div class="backstage_tab">
    <!-- NewsTable -->
    <SearchQuery
      @clearData="clearData"
      @handleChange="handleChange"
      @letterVal="letterVal"
      :isAddNew="false"
      @searchData="searchData"
      :isChange="isChange"
      :active="active"
      :brandSelect="brandSelect"
    ></SearchQuery>

    <!-- 数据表格 -->
    <div class="table">
      <table-tem :column="column" :tableData="tableData" @rowClick="rowClick">
        <template slot="other">
          <el-table-column label="Operation" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeStatus(scope)"
              ></el-switch>
            </template>
          </el-table-column>
        </template>
      </table-tem>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
        class="page"
        v-if="total != 0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { alphabeticQuery, NewsTable, Tab2Column } from "@/conf/Backstage.js";
import TableTem from "@/common/components/table";
import SearchQuery from "./SearchQuery.vue";
import { getNewsList, updateStatus } from "@/common/js/http/version3Api.js";
import qs from "qs";

export default {
  name: "NewsTable",
  components: {
    TableTem,
    SearchQuery,
  },
  props: ["brandSelect"],
  data() {
    return {
      alphabeticQuery,
      inputValue: "",
      tableCols: NewsTable,
      column: Tab2Column,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      keyWords: "",
      isChange: -1,
      active: "",
      letter: "",
      companyId: "",
    };
  },

  created() {
    sessionStorage.setItem("detailnews", true);
    this.getList();
  },
  mounted() {
    // console.log(sessionStorage.getItem("inpVal"), this.companyId, "companyId");
    this.getDetailNews();
  },

  methods: {
    async handleChange(val) {
      this.companyId = val;
      sessionStorage.setItem("companyId", val);
      if (val !== "") {
        const params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          keyWords: this.keyWords,
          companyId: this.companyId,
          letter: this.letter,
          brandToken: localStorage.getItem("brand-token"),
        };
        const { result } = await getNewsList(qs.stringify(params));

        this.tableData = result.list;
        this.tableData.filter((item) => {
          if (Object.prototype.toString.call(item.status) == "[object Null]") {
            item.status = 0;
          }
        });
        this.total = result.totalElements;
      } else {
        const params = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          keyWords: this.keyWords,
          companyId: this.companyId,
          letter: this.letter,
        };
        const { result } = await getNewsList(qs.stringify(params));
        
        this.tableData = result.list;
        this.tableData.filter((item) => {
          if (Object.prototype.toString.call(item.status) == "[object Null]") {
            item.status = 0;
          }
        });
        this.total = result.totalElements;
      }
    },
    async getList() {
      const params = {
        currentPage: sessionStorage.getItem("pageCurrent")
          ? sessionStorage.getItem("pageCurrent")
          : this.currentPage,
        pageSize: this.pageSize,
        keyWords:
          sessionStorage.getItem("inpVal") == null
            ? this.keyWords
            : sessionStorage.getItem("inpVal"),
        companyId:
          sessionStorage.getItem("companyId") == null
            ? this.companyId
            : sessionStorage.getItem("companyId"),
        letter: this.letter,
        brandToken: localStorage.getItem("brand-token"),
      };
      const { result } = await getNewsList(qs.stringify(params));
      this.tableData = result.list;
      this.tableData.filter((item) => {
        if (Object.prototype.toString.call(item.status) == "[object Null]") {
          item.status = 0;
        }
      });
      this.total = result.totalElements;
    },

    select(row) {},

    letterVal(searchQuery, index) {
      this.letter = searchQuery.letterVal;

      if (index != this.isChange) {
        this.isChange = index;
        this.active = searchQuery.letterVal;
        this.getList();
      } else {
        this.isChange = -1;
        this.active = "";
        //this.keyWords = "";
        this.letter = "";
        this.getList();
      }
    },
    searchData(searchString) {
      this.keyWords = searchString.inpVal;
      sessionStorage.setItem("inpVal", searchString.inpVal);
      this.getList();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      sessionStorage.setItem("pageCurrent", val);
      this.getList();
    },

    async changeStatus(scope) {
      const params = {
        id: scope.row.id,
        status: scope.row.status,
        brandToken: localStorage.getItem("brand-token"),
      };
      await updateStatus(qs.stringify(params));
      this.$message({
        message: "Operation successful !",
        type: "success",
      });
    },

    rowClick(row, column, cell, event) {
      if (column.label == "Operation") {
        return;
      } else {
        this.$router.push({
          name: "MArticleDetail",
          query: {
            id: this.$route.query.id,
            detailId: row.id,
          },
        });
      }
    },
    getDetailNews() {
      if (this.$route.query.id == sessionStorage.getItem("id")) {
        //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值赋值，用以返回前的页面，保持不变
        if (sessionStorage.getItem("detailnews")) {
          this.pageSize = 10;
          this.currentPage = Number(sessionStorage.getItem("pageCurrent"));
          this.companyId = sessionStorage.getItem("companyId");
          this.keyWords = sessionStorage.getItem("inpVal");
        } else {
          this.pageSize = 10;
          this.currentPage = 1;
          this.companyId = "";
          this.keyWords = "";
          //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
          sessionStorage.removeItem("pageCurrent");
          sessionStorage.removeItem("companyId");
          sessionStorage.removeItem("inpVal");
        }
      }
    },
    clearData() {
      sessionStorage.removeItem("pageCurrent");
      this.currentPage = 1;
      this.getList();
    },
  },
  destroyed() {
    sessionStorage.removeItem("detailnews");
  },
};
</script>

<style scoped>
.backstage_tab {
  /* min-height: 300px; */
  margin: 20px 0;
}

.page {
  text-align: center !important;
  padding: 20px;
}
</style>
